import { qrcanvas } from 'qrcanvas';
import iconStyle from '../styles/iconfont.less';
export const importCDN = (url, name) =>
  new Promise(resolve => {
    const dom = document.createElement('script');
    dom.src = url;
    dom.type = 'text/javascript';
    dom.onload = () => {
      resolve(window[name]);
    };
    document.head.appendChild(dom);
  });

export const importAudio = uniqueId => {
  const audio = document.createElement('audio');
  audio.id = uniqueId;
  audio.autoplay = true;
  audio.preload = true;
  audio.controls = true;
  audio.style.display = 'none';
  document.body.appendChild(audio);
  return audio;
};

export const addClass = (node, className) => {
  if (!node) return;
  node.classList.add(className);
};

export const removeClass = (node, className) => {
  if (!node) return;
  node.classList.remove(className);
};

export const hideNode = (node, timeout = 500) => {
  if (!node) return;
  setTimeout(() => {
    node.style.display = 'none';
  }, timeout);
};

export const isObject = o => {
  return typeof o === 'object' && o !== null && o.constructor && o.constructor === Object;
};

export const extendParams = (...args) => {
  const params = args[0];
  if (!isObject(params)) return;
  for (let [key, value] of Object.entries(params)) {
    args[1][key] = value;
  }
  return args[1];
};

export function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}

export function isPc() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod');
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

export function isAndroid() {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  return isAndroid;
}

export function isIos() {
  var u = navigator.userAgent,
    app = navigator.appVersion;
  var isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  return isIos;
}

export function creatQrcodeImg(params) {
  if (!params) return false;
  const { logo, url } = params;
  // const colorFore = '#007aff';
  // const colorOut = '#ff8080';
  // const colorIn = '#0059b3';
  const colorFore = '#333';
  const colorOut = '#333';
  const colorIn = '#333';
  const size = isPc() ? 300 : 200;
  let options = {
    data: url,
    size: size,
    correctLevel: 'H',
    foreground: [
      // foreground color
      { style: colorFore },
      // outer squares of the positioner
      { row: 0, rows: 7, col: 0, cols: 7, style: colorOut },
      { row: -7, rows: 7, col: 0, cols: 7, style: colorOut },
      { row: 0, rows: 7, col: -7, cols: 7, style: colorOut },
      // inner squares of the positioner
      { row: 2, rows: 3, col: 2, cols: 3, style: colorIn },
      { row: -5, rows: 3, col: 2, cols: 3, style: colorIn },
      { row: 2, rows: 3, col: -5, cols: 3, style: colorIn },
    ],
  };
  if (logo) {
    const image = new Image();
    image.setAttribute('crossOrigin', 'Anonymous');
    image.src = logo;
    image.width = '50';
    image.height = '50';
    image.style.borderRadius = '50px';
    image.onload = () => {
      options.logo = { image: image };
      if (params.success) {
        params.success(createCodeImg(options));
      }
    };
  } else {
    if (params.success) {
      params.success(createCodeImg(options));
    }
  }
}

function drawRoundRect(ctx, r, x, y, w, h, img) {
  ctx.save();
  if (w < 2 * r) {
    r = w / 2;
  }
  if (h < 2 * r) {
    r = h / 2;
  }
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
  ctx.clip();
  ctx.drawImage(img, x, y, w, h);
  ctx.restore(); // 返回上一状态
}

function createCodeImg(options) {
  const { logo, ...params } = options;
  const canvas = qrcanvas(params);
  const ctx = canvas.getContext('2d');
  if (logo) {
    const size = isPc() ? 300 : 200;
    const logosize = 50;
    drawRoundRect(
      ctx,
      5,
      (size - logosize) / 2,
      (size - logosize) / 2,
      logosize,
      logosize,
      logo.image,
    );
  }
  const codeImg = canvas.toDataURL('image/jpg');
  return codeImg;
  // document.getElementById(styles['qrcode-wrapper']).appendChild(canvas);
}

export function humpToLine(value) {
  const re = /[A-Z]/g;
  const str = value.replace(re, function($0, $1, $2) {
    return '-' + $0.toLowerCase();
  });
  return str;
}

export function jsToCss(obj) {
  let str = '';
  Object.keys(obj).forEach(key => {
    str += `${humpToLine(key)}:${obj[key]};`;
  });
  return str;
}

export function hexToRgb(value) {
  if (!value) return;
  // 16进制颜色值的正则
  const reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
  // 把颜色值变成小写
  let color = value.toLowerCase();
  if (reg.test(color)) {
    // 如果只有三位的值，需变成六位，如：#fff => #ffffff
    if (color.length === 4) {
      let colorNew = '#';
      for (let i = 1; i < 4; i += 1) {
        colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
      }
      color = colorNew;
    }
    // 处理六位的颜色值，转为RGB
    const colorChange = [];
    for (let i = 1; i < 7; i += 2) {
      colorChange.push(parseInt('0x' + color.slice(i, i + 2)));
    }
    return {
      r: colorChange[0],
      g: colorChange[1],
      b: colorChange[2],
    };
  } else {
    return color;
  }
}
export function rgbToHex(value) {
  const reg = /^(rgb|RGB)/;
  let color = value;
  if (reg.test(color)) {
    let strHex = '#';
    // 把RGB的3个数值变成数组
    const colorArr = color.replace(/(?:\(|\)|rgb|RGB)*/g, '').split(',');
    // 转成16进制
    for (let i = 0; i < colorArr.length; i++) {
      let hex = Number(colorArr[i]).toString(16);
      if (hex === '0') {
        hex += hex;
      }
      strHex += hex;
    }
    return strHex;
  } else {
    return String(color);
  }
}
export function iconfont(name, classname) {
  return `<i class="${iconStyle.iconfont} ${iconStyle[name]} ${classname || ''}"></i>`;
}

export function splitArr(data,type){
  var arr = data.split(type);
  return arr;
}
